export default __webpack_public_path__ + "static/openHand-746adc6adefd4d2ba76ee848b2f24c3e.png";